import React from 'react';
import { useQuery } from '@apollo/client';
import { Select, Space, Typography } from 'antd';
import { GET_FACULTIES } from 'gql/faculties';
import { SelectWithSearch } from 'components/input';

const { Text } = Typography;
const { Option } = Select;

const ProTableSearchDepartment = ({ faculty, value, onChange, ...rest }) => {
  const { data, loading } = useQuery(GET_FACULTIES);

  const options = data
    ? data.faculties
        .filter(({ id }) => (faculty ? id === faculty : true))
        .map(({ departments }) => {
          return departments.map(({ id, name, abbreviation, disabled }) => ({
            id,
            name,
            abbreviation,
            disabled,
          }));
        })
        .flat()
        .filter(({ disabled }) => !disabled)
    : [];

  // clear
  return (
    <SelectWithSearch
      loading={loading}
      value={value}
      onChange={onChange}
      optionLabelProp="label"
      {...rest}
    >
      {options.map(({ id, name, abbreviation }) => (
        <Option
          key={id}
          value={id}
          label={abbreviation}
          searchfrom={`${name} ${abbreviation}`}
        >
          <Space direction="vertical">
            {abbreviation}
            <Text type="secondary">{name}</Text>
          </Space>
        </Option>
      ))}
    </SelectWithSearch>
  );
};

export default ProTableSearchDepartment;
